module.exports = __webpack_public_path__ + "static/img/gd-05.4b535c52.jpg";